import { render, staticRenderFns } from "./Suporte2.vue?vue&type=template&id=1e3615cc&scoped=true"
import script from "./Suporte2.vue?vue&type=script&lang=js"
export * from "./Suporte2.vue?vue&type=script&lang=js"
import style0 from "./Suporte2.vue?vue&type=style&index=0&id=1e3615cc&prod&lang=css"
import style1 from "./Suporte2.vue?vue&type=style&index=1&id=1e3615cc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e3615cc",
  null
  
)

export default component.exports